import React from 'react';
import PlainText from '@components/plain-text';
import classnames from 'classnames';
import * as styles from './RatingHeader.scss';
import { toThousandSeparatedNumber, getFormattedText } from '../../utils';
import strings from '../../strings';

const RatingHeader = ({ count, isMobile }) => (
  <div className={styles.header}>
    <div
      className={classnames(styles.counter, styles.counterHeader)}
    >
      {`${toThousandSeparatedNumber(count)} ${getFormattedText('participants', count)}`}
    </div>
    {!isMobile && (
      <>
        <PlainText
          size="txt-12"
          color="neutral-tone-4"
          className={styles.passport}
        >
          {strings.passport}
        </PlainText>
        <PlainText
          size="txt-12"
          color="neutral-tone-4"
          className={styles.recs}
        >
          {strings.recs}
        </PlainText>
        <PlainText
          size="txt-12"
          color="neutral-tone-4"
          className={styles.claims}
        >
          {strings.claimsTitle}
        </PlainText>
      </>
    )}
  </div>
);

export default RatingHeader;
